import Carga from '@/model/resource/Carga'
import CargaCsvSimplificadoSemCheckAtendimentoSchema from '@/schema/CargaCsvSimplesSemCheckAtendimentoSchema.schema'

export default class CargaCsvSimplesSemCheckAtendimento extends Carga {

    get $schema() {
        return CargaCsvSimplificadoSemCheckAtendimentoSchema(this)
    }

}
